import React from "react";
import { Helmet } from "react-helmet";

// Components
import Loader from "../components/common/Loader";
import Menu from "../components/home1/Menu";
import Navbar from "../components/home1/Navbar";
import Header from "../components/home1/Header";
import Experience from "../components/home1/Experience";
import Services from "../components/home1/Services";
import Process from "../components/home1/Process";
import About from '../components/home10/About';
import Projects from "../components/home1/Projects";
import Apartments from "../components/home5_residence/Apartments";
import Footer2 from "../components/home2/Footer";
import NewsletterSignup from "../components/home1/News";

function Home1() {
  return (
    <>
      <Helmet>
        {/* CSS Styles */}
        <link
          rel="stylesheet"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          href="/home5_residence/assets/css/home_5_style.css"
        />
        <link
          rel="stylesheet"
          href="/home2/assets/css/home_2_style.css"
        />
        <link rel="stylesheet" href="/home10/assets/css/home_10_style.css" />

        {/* JS Scripts */}
        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home5_residence/assets/js/home_5_scripts.js" defer></script>
        <script src="/home10/assets/js/home_10_scripts.js"></script>
         <meta
          name="description"
          content="Botanicheska 302 е нова жилищна сграда в Св. Св. Константин и Елена с модерна архитектура, апартаменти с панорама, зеленина и стилно ново строителство."
        />
      </Helmet>
{/*Irina */}
      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <Experience />
            <Services />
            <Process />
            <Projects />
            {/* <Apartments className="mt-10" /> */}
            <About/>
            {/* <NewsletterSignup /> */}
          </main>
          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Home1;
